export default "__VITE_ASSET__D6c7xBL9__"